import { Box, IconButton } from "@mui/material";
import { styles } from "./stylesCategory";
import CustomFilter from "@/components/UI/CustomFilter/CustomFilter";
import RefreshSvg from "@/assets/svg/RefreshSvg";

interface CategoryProps {
  posts?: boolean;
  selectedCategory: {
    parent: string;
    child?: string;
  };
  setSelectedCategory: React.Dispatch<React.SetStateAction<{ parent: string; child?: string }>>;
  onRefreshPosts?: () => void;
  selectedFilters?: ("New" | "Top")[];
  setSelectedFilters?: (value: ("New" | "Top")[]) => void;
  sortDirection?: "asc" | "desc";
  setSortDirection?: (value: "asc" | "desc") => void;
}

export const Category = ({
  posts = true,
  selectedCategory,
  setSelectedCategory,
  onRefreshPosts,
  selectedFilters,
  setSelectedFilters,
}: CategoryProps) => {
  const filterOptions: ("New" | "Top")[] = ["New", "Top"];

  const categoryOptions = ["All", "Stocks", "Economics", "Personal"];

  type CategorySubOptions = Record<string, { key: string; label: string }[]>;

  const categorySubOptions: CategorySubOptions = {
    Stocks: [
      { key: "stocks_all", label: "All" },
      { key: "technical", label: "Technical" },
      { key: "fundamental", label: "Fundamental" },
    ],
  };

  const categoryLabel = (() => {
    if (!selectedCategory.parent) return "Category";

    if (selectedCategory.child) {
      const match = categorySubOptions[selectedCategory.parent]?.find(
        (item: { key: string; label: string }) => item.key === selectedCategory.child
      );

      return `${selectedCategory.parent} - ${match?.label || ""}`;
    }
    return selectedCategory.parent;
  })();

  return (
    <Box sx={{ ...styles.root, height: posts ? "88px" : "60%" }}>
      <Box sx={styles.wrapper}>
        <Box sx={styles.leftControls}>
          <Box sx={styles.buttonGroup}>
            {filterOptions.map((option) => (
              <CustomFilter
                key={option}
                label={option}
                isActive={selectedFilters?.includes(option)}
                onSelect={() => {
                  if (!setSelectedFilters) return;
                  setSelectedFilters([option]);
                }}
                width={67}
              />
            ))}
          </Box>

          <CustomFilter
            label={categoryLabel}
            isDropdown
            options={categoryOptions}
            expandableOptions={categorySubOptions}
            isActive={!!selectedCategory.parent}
            selectedValue={selectedCategory.child}
            onSelect={(value) => {
              const matchedParent = Object.entries(categorySubOptions).find(([, children]) =>
                children.some((child) => child.key === value)
              );

              if (matchedParent) {
                const [parent] = matchedParent;
                setSelectedCategory({ parent, child: value });
              } else {
                setSelectedCategory({ parent: value });
              }
            }}
          />
        </Box>

        {!selectedFilters?.includes("New") && (
          <Box sx={styles.iconButtons}>
            <IconButton size="small" onClick={onRefreshPosts}>
              <RefreshSvg />
            </IconButton>
          </Box>
        )}
      </Box>
    </Box>
  );
};
